export default {"src":"/_next/static/media/channel-finance.ca53a78e.svg","height":432,"width":552};